import type { OpenAPIV3 } from 'openapi-client-axios';
import { OpenAPIClientAxios } from 'openapi-client-axios';
import type { Client } from './__generated__/openapi-types';
import {
  addAuthInterceptor,
  addErrorInterceptor,
  SuperDutyError,
} from './lib/api/index';

import definitionJson from './__generated__/openapi.json';

const definition: OpenAPIV3.Document = definitionJson;

// Create the OpenAPI client
const apiClient = new OpenAPIClientAxios({
  definition,
  axiosConfigDefaults: {
    baseURL: import.meta.env.VITE_API_URL,
  },
});

// Initialize the client
let api: Client;

// Create and initialize the API client
const initApi = async () => {
  api = await apiClient.getClient();

  // Add interceptors
  addAuthInterceptor(api);
  addErrorInterceptor(api);

  return api;
};

export { api, initApi, SuperDutyError };
